module.exports = __webpack_public_path__ + "img/img_28.1e2f5054.svg";